import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';
import { Request } from '../../types';
import { get } from '../../utils/api';
import AttendeeSlot from './AttendeeSlot';
import '../profile/SlotList.css';
import DateSwitch from '../common/DateSwitch';

type Requests = {
    requests: Request[]
};

export interface AttendeeSlotsProps {
	attendee_id: number;
    request?: Request; // Мой запрос к этому участнику, если есть
};
//
// Список слотов участника.
// Компонент запрашивает список запросов участника от имени залогиненого участника.
//
const AttendeeSlots: FC<AttendeeSlotsProps> = ({ attendee_id, request }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
	const slots = useAppSelector(store => store.slots);
    const [ requests, setRequests ] = useState<Request[]>([]);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState('');
    const [ date, setDate ] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setError('');
            setRequests([]);
            const result = await get('/requests', { attendee_id });
            if(result.error) {
                setError(result.error.text[lang]);
            } 
            if(result.data) {
                setRequests((result.data as Requests).requests);
            }
            setIsLoading(false);
        };
        fetchData();
        // ВНИМАНИЕ! При отмене или переносе запроса, необходимо заново
        // запрашивать список запросов контрагента для отображения
        // освободившихся слотов. Но просто вставить в зависимости request
        // нельзя т.к. тогда компонент будет моргать при каждом обновлении
        // списка запросов пользователя по таймеру.
        // Как решить проблему пока не ясно.
        // Утешает то, что это не частый случай.
	}, [ attendee_id, lang ]);

	if(!slots || slots.length === 0) return null;
    if(isLoading) return <p>{t('common.loading')}</p>;
    if(error) return <p className='error'>{error}</p>;

	return (
        <div>
            <DateSwitch current={date} onChange={setDate} className='oldlace'/>
            <div className='SlotList'>
                {slots.map(slot => slot.start.startsWith(date) ? <AttendeeSlot key={slot.id} slot={slot} requests={requests} request={request}/> : null)}
            </div>
        </div>
	);
};

export default AttendeeSlots;
